import { createLazyComponent } from 'owa-bundling';
import { lazySingleLineViewModule, lazyThreeColumnViewModule } from './lazyFunctions';

// components
export { default as MailListItem } from './components/MailListItem';

// lazy components
export const MailListItemCondensedThreeColumn = createLazyComponent(
    lazyThreeColumnViewModule,
    m => m.MailListItemCondensedThreeColumn
);
export const MailListItemFullThreeColumn = createLazyComponent(
    lazyThreeColumnViewModule,
    m => m.MailListItemFullThreeColumn
);
export const MailListItemSingleLineView = createLazyComponent(
    lazySingleLineViewModule,
    m => m.MailListItemSingleLineView
);
